import React from 'react';

function Card({children, color}) {
    return (
        <div className={"br2 navy pa3 ma3 " + color }>
            {children}
        </div>
    )
}

Card.defaultProps = { color: "bg-lightest-blue" }

export default Card